import ExchangeOrderList from '@/pages/exchange/ExchangeOrderList.vue';
import ExchangeOrderDetail from '@/pages/exchange/ExchangeOrderDetail.vue';
import MaterialList from '@/pages/exchange/MaterialList.vue';
import MaterialForm from '@/pages/exchange/MaterialForm.vue';

export default [
  {
    path: '/exchange/orders',
    name: 'exchange-order-list',
    component: ExchangeOrderList,
  },
  {
    path: '/exchange/orders/:orderId',
    name: 'exchange-order-detail',
    component: ExchangeOrderDetail,
  },
  {
    path: '/projects/:projectId/materials',
    name: 'material-list',
    component: MaterialList,
  },
  {
    path: '/projects/:projectId/materials/:id',
    name: 'material-form',
    component: MaterialForm,
  },
];
